import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconPersonLimitedSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6665 5.33329C10.6665 6.80663 9.47317 7.99996 7.99984 7.99996C6.5265 7.99996 5.33317 6.80663 5.33317 5.33329C5.33317 3.85996 6.5265 2.66663 7.99984 2.66663C9.47317 2.66663 10.6665 3.85996 10.6665 5.33329ZM7.99984 6.66663C8.11932 6.66663 8.23512 6.65095 8.34527 6.62153L6.71159 4.98786C6.68218 5.09801 6.6665 5.2138 6.6665 5.33329C6.6665 6.07025 7.26288 6.66663 7.99984 6.66663ZM7.6544 4.04505L9.28808 5.67873C9.31749 5.56857 9.33317 5.45278 9.33317 5.33329C9.33317 4.59634 8.73679 3.99996 7.99984 3.99996C7.88035 3.99996 7.76456 4.01564 7.6544 4.04505Z"
        fill="currentColor"
      />
      <path
        d="M2.6665 12C2.6665 10.2266 6.21984 9.33329 7.99984 9.33329C9.77984 9.33329 13.3332 10.2266 13.3332 12V13.3333H2.6665V12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
